import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const GameCatalog = lazy(() => import('../pages/game-catalog/page'));
const GameDetail = lazy(() => import('../pages/game-detail/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const HelpCenter = lazy(() => import('../pages/help/page'));
const FAQs = lazy(() => import('../pages/faqs/page'));
const PaymentMethods = lazy(() => import('../pages/payments/page'));
const WithdrawalGuide = lazy(() => import('../pages/withdrawals/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacy/page'));
const TermsOfService = lazy(() => import('../pages/terms/page'));
const Disclaimer = lazy(() => import('../pages/disclaimer/page'));
const ResponsibleGaming = lazy(() => import('../pages/responsible-gaming/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/games',
    element: <GameCatalog />
  },
  {
    path: '/game/:slug',
    element: <GameDetail />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/help',
    element: <HelpCenter />
  },
  {
    path: '/faqs',
    element: <FAQs />
  },
  {
    path: '/payments',
    element: <PaymentMethods />
  },
  {
    path: '/withdrawals',
    element: <WithdrawalGuide />
  },
  {
    path: '/privacy',
    element: <PrivacyPolicy />
  },
  {
    path: '/terms',
    element: <TermsOfService />
  },
  {
    path: '/disclaimer',
    element: <Disclaimer />
  },
  {
    path: '/responsible-gaming',
    element: <ResponsibleGaming />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
